import { useEffect, useMemo, useState } from "react";
import fetchClient from "../../../../axios/fetch";
import EditEntityModal from "./EditEntityModal";

const EntitiesDialog = ({
    mode,
    selected,
    entities,
    setEntities,
    toggleDialog,
    setNotif,
    getEntities,
}) => {
    const [countries, setCountries] = useState([]);
    const [cities, setCities] = useState([]);

    useEffect(() => {
        fetchCountries();
        fetchCities();
    }, []);

    const fetchCountries = () => {
        fetchClient()
            .get("api/country/getallcountry")
            .then((res) => {
                setCountries(res?.data?.data || []);
            })
            .catch(() => {
                setCountries([]);
            });
    };

    const fetchCities = () => {
        fetchClient()
            .get("api/city")
            .then((res) => {
                setCities(res?.data?.data || []);
            })
            .catch(() => {
                setCities([]);
            });
    };

    const normalizedEntity = useMemo(() => {
        if (!selected) return null;

        return {
            ...selected,
            id: selected.id ?? selected.entityId ?? 0,
            entityName: selected.entityName || "",
            countryId: selected.countryId ?? selected.country?.id ?? null,
            cityId: selected.cityId ?? selected.city?.id ?? null,
            status:
                typeof selected.status === "boolean"
                    ? selected.status
                    : typeof selected.isActive === "boolean"
                        ? selected.isActive
                        : true,
        };
    }, [selected]);

    const showNotif = (isSuccess, customMsg) => {
        setNotif({
            type: isSuccess ? "success" : "error",
            msg:
                customMsg ||
                (isSuccess
                    ? `Entity ${mode === "edit" ? "updated" : "created"} successfully.`
                    : "Oops... something went wrong while saving the entity."),
        });

        setTimeout(() => {
            setNotif({
                type: "success",
                msg: "",
            });
        }, 10000);
    };

    const handleSave = async (formData) => {
        const countryId =
            formData.country?.id ??
            formData.country?.countryId ??
            normalizedEntity?.countryId ??
            null;

        const cityId =
            formData.city?.id ??
            formData.city?.cityId ??
            normalizedEntity?.cityId ??
            null;

        const basePayload = {
            EntityName: formData.entityName,
            CityId: cityId,
            CountryId: countryId,
            IsActive: formData.status,
        };

        const payload =
            mode === "edit"
                ? {
                    id: normalizedEntity?.id,
                    ...basePayload,
                }
                : basePayload;

        try {
            // Mock mode for local validation of create/edit without backend persistence.
            // if (mode === "edit") {
            //     setEntities((prev) =>
            //         prev.map((item) => (item.id === payload.id ? { ...item, ...payload } : item))
            //     );
            // } else {
            //     setEntities((prev) => [...prev, payload]);
            // }

            // Uncomment to enable API persistence.
            if (mode === "edit") {
                await fetchClient().put("api/entity", payload);
            } else {
                await fetchClient().post("api/entity", payload);
            }

            showNotif(true);
            getEntities?.();
            toggleDialog();
        } catch (error) {
            const serverMessage =
                error?.response?.data?.message || error?.response?.data || undefined;
            showNotif(false, serverMessage);
        }
    };

    return (
        <EditEntityModal
            open={true}
            onClose={toggleDialog}
            onSave={handleSave}
            entityData={normalizedEntity}
            countries={countries}
            cities={cities}
            existingEntities={entities}
            mode={mode}
        />
    );
};

export default EntitiesDialog;
